/**
 * LOS AVISOS DE NUTRICIÓN QUE EL CLIENTE HA CERRADO (Jesús, 28-09, audio de las 22:21).
 *
 *     «Cuando se hagan como estos mensajes, tiene que aparecer arriba una cruz de cerrar la
 *      ventana. Que yo pueda cerrar la ventana... Yo cierro la ventana y ya está. [...] Me
 *      cambio al día anterior, vuelvo al día actual y me vuelve a salir.»
 *
 * Así que un aviso cerrado se queda cerrado PARA ESE DÍA aunque se cambie de día y se
 * vuelva. Se guarda por cliente, por aviso y por fecha, en `sessionStorage`: dura lo que
 * dura la pestaña abierta, que es la «misma sesión» en la que lo cerró.
 *
 * Y con una HUELLA: lo que hacía verdad el aviso cuando se cerró. Si cambia (por ejemplo,
 * le ponen macros nuevos y el descuadre es otro), el aviso vuelve a salir, porque ya no es
 * el mismo aviso. Sin huella (cadena vacía) se cierra y ya.
 *
 * Todo con try/catch: con el almacén bloqueado (modo privado, vista previa) no se recuerda
 * nada y el aviso simplemente vuelve a salir, que es lo de antes.
 */

const clave = (userId) => (userId ? `u:${userId}:avisos-cerrados` : null);

const almacenPorDefecto = () => {
    try { return window.sessionStorage; } catch { return null; }
};

const leerTodo = (userId, almacen) => {
    const k = clave(userId);
    if (!k || !almacen) return {};
    try {
        const crudo = almacen.getItem(k);
        const dato = crudo ? JSON.parse(crudo) : {};
        return dato && typeof dato === 'object' ? dato : {};
    } catch { return {}; }
};

const escribirTodo = (userId, almacen, dato) => {
    const k = clave(userId);
    if (!k || !almacen) return;
    try { almacen.setItem(k, JSON.stringify(dato)); } catch { /* lleno o bloqueado */ }
};

const id = (aviso, fecha) => `${aviso}|${fecha}`;

/** La huella de un objetivo de macros del día, a la décima: si cambian, cambia. */
export const huellaDelObjetivo = (objetivo) => {
    const o = objetivo || {};
    const d = (v) => (Math.round((Number(v) || 0) * 10) / 10).toFixed(1);
    return `${d(o.P_total ?? o.P)}/${d(o.H_total ?? o.H)}/${d(o.G_total ?? o.G)}`;
};

export const estaCerrado = (userId, aviso, fecha, huella = '', almacen = almacenPorDefecto()) => {
    if (!fecha) return false;
    const todo = leerTodo(userId, almacen);
    return Object.prototype.hasOwnProperty.call(todo, id(aviso, fecha))
        && todo[id(aviso, fecha)] === huella;
};

export const cerrarAviso = (userId, aviso, fecha, huella = '', almacen = almacenPorDefecto()) => {
    if (!fecha) return;
    const todo = leerTodo(userId, almacen);
    todo[id(aviso, fecha)] = huella;
    escribirTodo(userId, almacen, todo);
};

export const reabrirAviso = (userId, aviso, fecha, almacen = almacenPorDefecto()) => {
    if (!fecha) return;
    const todo = leerTodo(userId, almacen);
    if (!(id(aviso, fecha) in todo)) return;
    delete todo[id(aviso, fecha)];
    escribirTodo(userId, almacen, todo);
};
